import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DateService {
  
  /**
   * Az aktuális dátum és idő formázott stringként való visszaadása
   * @returns string formátumú dátum és idő (YYYY-MM-DDThh:mm)
   */
  getCurrentDateTime(): string {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    
    return `${year}-${month}-${day}T${hours}:${minutes}`;
  }

  /**
   * Dátum validálása és frissítése ha szükséges
   * @param selectedDate - A kiválasztott dátum string formátumban
   * @returns Az érvényes dátum string formátumban
   */
  validateAndUpdateDate(selectedDate: string): string {
    const selected = new Date(selectedDate);
    const current = new Date();
    
    
    // Ha a kiválasztott dátum korábbi mint a jelenlegi, visszaadjuk a jelenlegi dátumot
    if (selected < current) {
      return this.getCurrentDateTime();
    }
    
    return selectedDate;
  }
}
